import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_property_editor = _resolveComponent("ontos-property-editor")!
  const _component_ontos_unsaved_changes_dialog = _resolveComponent("ontos-unsaved-changes-dialog")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { "phone-flush": "" }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createBlock(_component_ontos_property_editor, {
            key: 0,
            idea: _ctx.idea,
            workspace: _ctx.workspace,
            property: _ctx.property,
            identifier: _ctx.identifier,
            start: _ctx.start,
            saving: _ctx.savingProperty,
            onSave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.save($event)))
          }, {
            controls: _withCtx(({dirty}) => [
              _createVNode(_component_ontos_header_action, {
                icon: "mdi-arrow-left",
                label: _ctx.$tt('back'),
                onClick: ($event: any) => (_ctx.onBack(dirty))
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["idea", "workspace", "property", "identifier", "start", "saving"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ontos_unsaved_changes_dialog, {
        leaving: _ctx.leaving,
        onConfirmed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToDesign())),
        onCancelled: _cache[2] || (_cache[2] = ($event: any) => (_ctx.leaving = null))
      }, null, 8, ["leaving"])
    ]),
    _: 1
  }, 16))
}